<template>
  <div class="wysiwyg-editor">
    <editor-menu-bar class="pb-4" :editor="editor" v-slot="{ commands, isActive }">
      <div>
        <div class="btn-toolbar">
          <div class="btn-group mr-2">
            <base-button v-tooltip="'Bold'" :active="isActive.bold()" @click="commands.bold" icon-right="bold" />
            <base-button v-tooltip="'Italic'" :active="isActive.italic()" @click="commands.italic" icon-right="italic" />
            <base-button v-tooltip="'Strikethrough'" :active="isActive.strike()" @click="commands.strike" icon-right="strikethrough" />
            <base-button v-tooltip="'Underline'" :active="isActive.underline()" @click="commands.underline" icon-right="underline" />
          </div>
          <div class="btn-group mr-2">
            <base-button v-tooltip="'Unordered List'" :active="isActive.bullet_list()" @click="commands.bullet_list" icon-right="list-ul" />
            <base-button v-tooltip="'Ordered List'" :active="isActive.ordered_list()" @click="commands.ordered_list" icon-right="list-ol" />
          </div>
          <div class="btn-group mr-2">
            <base-button v-tooltip="'Heading Level'" dropdown icon-left="heading">
              <template v-if="isActive.heading({ level: 1 })">
                Heading 1
              </template>
              <template v-else-if="isActive.heading({ level: 2 })">
                Heading 2
              </template>
              <template v-else-if="isActive.heading({ level: 3 })">
                Heading 3
              </template>
              <template v-else-if="isActive.heading({ level: 4 })">
                Heading 4
              </template>
              <template v-else-if="isActive.heading({ level: 5 })">
                Heading 5
              </template>
              <template v-else-if="isActive.heading({ level: 6 })">
                Heading 6
              </template>
              <template v-else>
                Heading
              </template>
            </base-button>
            <div class="dropdown-menu">
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 1 })">
                Heading 1
              </a>
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 2 })">
                Heading 2
              </a>
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 3 })">
                Heading 3
              </a>
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 4 })">
                Heading 4
              </a>
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 5 })">
                Heading 5
              </a>
              <a href="#" class="dropdown-item" @click.prevent="commands.heading({ level: 6 })">
                Heading 6
              </a>
            </div>
          </div>
          <div class="btn-group">
            <base-button v-tooltip="'Undo'" @click="commands.undo" icon-right="undo" />
            <base-button v-tooltip="'Redo'"  @click="commands.redo" icon-right="redo" />
          </div>
        </div>
        <div class="buttons has-addons">
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            title="Heading 1"
            @click.prevent="commands.heading({ level: 1 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            title="Heading 2"
            @click.prevent="commands.heading({ level: 2 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            title="Heading 3"
            @click.prevent="commands.heading({ level: 3 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 4 }) }"
            title="Heading 4"
            @click.prevent="commands.heading({ level: 4 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 5 }) }"
            title="Heading 5"
            @click.prevent="commands.heading({ level: 5 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.heading({ level: 6 }) }"
            title="Heading 6"
            @click.prevent="commands.heading({ level: 6 })">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.blockquote() }"
            title="Blockquote"
            @click.prevent="commands.blockquote">
          </a>
          <a class="button"
            :class="{ 'is-active': isActive.code_block() }"
            title="Code block"
            @click.prevent="commands.code_block">
          </a>
          <a class="button"
            title="Undo"
            @click.prevent="commands.undo">
          </a>
          <a class="button"
            title="Redo"
            @click.prevent="commands.redo">
          </a>
        </div>
      </div>
    </editor-menu-bar>
    <editor-content class="editor" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  name: 'WysiwygEditor',

  components: {
    EditorContent,
    EditorMenuBar
  },

  props: {
    value: String
  },

  data () {
    return {
      editor: this.initializeEditor(),
      html: '',
      json: ''
    }
  },

  beforeDestroy () {
    this.editor.destroy()
  },

  methods: {
    initializeEditor () {
      const content = this.$_.clone(this.value)

      return new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content,
        onUpdate: ({ getHTML, getJSON }) => {
          this.html = getHTML()
          this.json = getJSON()
        }
      })
    }
  },

  watch: {
    html () {
      this.$emit('input', this.html)
    }
  }
}
</script>
